module.exports = "pegasus_template/assets/tech/birthday/101.png";